// extracted by mini-css-extract-plugin
export default {"root":"HelpDropdown_root__4sFMe","liink":"HelpDropdown_liink__kqokQ","text":"HelpDropdown_text__foRZ1"};